import tooltipster from 'tooltipster';

class Tooltipster {

    constructor() {
        this.initialize();
    }

    initialize() {
        $('[data-tooltipster]').tooltipster({
            theme: 'tooltip-borderless',
            contentAsHTML: true,
            interactive: true,
            side: 'right'
        });

        // tooltip вызываемый для html контента
        $('[data-tooltip-content]').tooltipster({
            animation: 'fade',
            delay: 200,
            theme: 'tooltipster-default',
            trigger: 'click',
            side: 'bottom',
            arrow: false
        });

        $('[data-tooltipster-close]').on('click', function() {
            $('[data-tooltip-content]').tooltipster('hide', function() {
                $('[data-tooltip-button]').removeClass('open')
            });
        })

        $('[data-tooltip-button]').on('click', function(e) {
            let el = $(this);
            el.addClass('open')
        });
    }
}

export {Tooltipster};

$(window).on('load', () => {
    new Tooltipster();
});
